const test = "http://127.0.0.1:8000";
const server = "https://prpublisher.reachableads.com";
const openserver = "http://192.168.68.57:8000";
const localserver = "https://617604e61ed0.ngrok-free.app";

const url = server + "/api/";

export const API_URL = url;
